import {CommonModule, NgOptimizedImage} from '@angular/common';
import {Component, HostListener, Input, OnInit} from '@angular/core';
import {Router, RouterLink} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';

import {NgClickOutsideDirective} from 'ng-click-outside2';

import {TranslationService} from '../../core/services/translation/translation.service';
import {AuthenticationService} from '../../core/services/authentication/authentication.service';
import {UserInfo} from '../../core/models/user/user-info.model';
import {LanguageSwitcherComponent} from '../../components/language-switcher/language-switcher.component';

@Component({
  selector: 'app-navbar',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    NgClickOutsideDirective,
    TranslateModule,
    NgOptimizedImage,
    LanguageSwitcherComponent
  ],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss'
})
export class NavbarComponent implements OnInit {

  @Input() navLight: any
  scrolled: boolean = false;
  menu: any
  subMenu: any
  open: any
  setUser: boolean = false

  constructor(
    private readonly router: Router,
    private readonly authenticationService: AuthenticationService
  ) {
  }

  get isAuthenticated(): boolean {
    return this.authenticationService.isAuthenticated;
  }

  get userData(): UserInfo | undefined {
    return this.authenticationService.userData;
  }

  get isPigletAllowed(): boolean {
    return this.authenticationService.isPigletAllowed;
  }

  @HostListener("window:scroll", [])

  onWindowScroll() {
    this.scrolled = window.scrollY > 0;
  }

  ngOnInit(): void {
    this.menu = this.router.url;
    window.scrollTo(0, 0);
  }

  openMenu(e: any, item: any) {
    if (this.subMenu === item) {
      this.subMenu = ''
    } else {
      this.subMenu = item
    }
  }

  toggleMenu(e: any) {
    e.preventDefault();
    this.open = !this.open
  }

  onClickedOutsideUser(e: Event) {
    this.setUser = false
  }

  logout(): void {
    this.authenticationService.logout();
    this.setUser = false;
    this.router.navigate(['/login']);
  }
}
